import { Field, Form, HousingAlert, Sender } from "@garantidos/components"

import Stepper from "@mobi/ds/components/Stepper"

import usePhoneNumber from "./hooks"

import "../../style.scss"

const PhoneNumberOneClick = () => {
  const {
    onSubmitCallback,
    handlePrevStep,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading,
    hasCpfFromHero
  } = usePhoneNumber()
  const { phone } = fields
  const { isValid } = form

  return (
    <div className="softleadSimulationOneClick">
      <div className="softleadSimulationOneClick__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <h1 className="softleadSimulationOneClick__title">
          e o número do seu celular?
        </h1>
        <Form onSubmit={onSubmitCallback} form={form}>
          <Field
            autoComplete="off"
            field={phone}
            form={form}
            data-testid={phone.name}
            disabled={isLoading}
            aria-labelledby=""
            aria-label={phone.ariaLabel}
          />
          <Sender
            id="btn-finish-softlead"
            onPrev={handlePrevStep}
            data_testid="submit"
            isNextDisabled={!isValid}
            nextLabel="avançar"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default PhoneNumberOneClick
